<template>
    <router-link :to="`#${id}`"
        ><h3 :id="id">{{ title }}</h3></router-link
    >
</template>

<script>
export default {
    name: 'chapterHeading',
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    computed: {
        id() {
            return this.$props.title
                .toLowerCase()
                .replace(/[#-:]/g, '')
                .replace(/^ | $/g, '')
                .replace(/ /g, '-');
        },
    },
};
</script>

<style scoped lang="sass">
a
	text-decoration: none
	color: black

	h3
		padding-top: 53px
</style>
